import { find } from "../../../orderBook/allGrids";
import { formatRuntime } from "../../../configTab/formik/time/utils";
import { AlgoConfiguration, Algo, direction, Direction } from "../../types";
import { remaining_quantity } from "../../utils";
import { getDebugMessage } from "./algoDebugMessageButton";
import { BaseColumns } from "./columns";
import { getPriceField } from "./getPriceField";
import { getAlgoBehavoir } from "./getAlgoBehavoir";
import { Price } from "../../../../price";

export const algoToRowData = (a: Algo<AlgoConfiguration>): BaseColumns => {
  const pdef = a.product_definitions[0];
  const displayGrid = find(pdef.delivery_area_id);

  let dir: Direction | undefined =
    "direction" in a.configuration && a.configuration.direction !== undefined
      ? direction(a.configuration.direction)
      : undefined;

  if (a.algo_data?.direction !== undefined) {
    dir = direction(a.algo_data.direction);
  }

  const price = getPriceField(a.algo_data, a.configuration);

  const quantity = remaining_quantity(
    a.state.trade_quantity,
    a.configuration,
    a.algo_data,
    a.algo_spec.name
  );

  const behavior = getAlgoBehavoir(a.algo_data);

  // Shimurai-only, and plain-decimal yen/MWh like `configuration.price` — the hub
  // echoes it back in the unit we sent it. Blank rather than "-" for the algos
  // that simply don't carry it, which is most of them.
  const margin_override =
    a.configuration.margin_override != null
      ? String(Price.fromYenPerMwh(a.configuration.margin_override).yenPerKwh)
      : "";

  const rowData: BaseColumns = {
    algo_id: a.algo_id,
    displayGrid,
    grid: pdef.delivery_area_id,
    algo: a.algo_spec.name,
    product: a.configuration.product_name,
    runtime: formatRuntime(a.start, a.end),
    id: a.algo_id,
    state: a.state.state,
    information:
      a.algo_data && "information" in a.algo_data
        ? a.algo_data.information
        : undefined,
    debugMessage: getDebugMessage(a),
    quantity,
    originalQuantity: a.configuration.quantity,
    price: price,
    margin_override,
    direction: dir,
    behavior: behavior,
    tag: a.configuration.tag,
    initials: a.configuration.initials,
    exchange: a.exchange,

    _delivery_start: pdef.delivery_start,
    _delivery_end: pdef.delivery_end,
  };
  return rowData;
};
